import axios from 'axios';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Typography,
    Button,
    Box,
    Grid,
    TextField,
    Card,
    CardHeader,
    CardContent,
} from '@mui/material';
import Banner from "../images/banner.png";
import Logo from "../images/nag_kitchen_logo.png";

export default function Registration() {
    const [formData, setFormData] = useState({
        firstname: '',
        lastname: '',
        username: '',
        password: '',
        confirmPassword: '',
    });

    const [error, setError] = useState('');
    const navigate = useNavigate();
    const serviceAPI = process.env.REACT_APP_API_SERVICE;

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (formData.password !== formData.confirmPassword) {
            setError('Passwords do not match');
            return;
        }
        setError('');

        try {
            const response = await axios.post(`${serviceAPI}/register`, formData);
            if (response.status === 201) {
                navigate('/registrationSuccess');
            } else {
                const errorText = await response.text();
                setError(errorText);
            }
        } catch (err) {
            setError('An error occurred during user registration');
        }
    };

    return (
        <Box
            sx={{
                backgroundImage: `url(${Banner})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                height: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                px: 2,
            }}
        >
            <Card
                sx={{
                    width: { xs: '100%', sm: 500, md: 600 },
                    border: '2px solid #356',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    boxShadow: 3,
                    borderRadius: 2,
                    padding: 3,
                    backdropFilter: 'blur(5px)',
                }}
            >
                <CardHeader
                    title={
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <img src={Logo} alt="Logo" style={{ height: '50px' }} />
                            <Typography variant="h5" fontWeight="bold">
                                Register Now
                            </Typography>
                        </Box>
                    }
                    sx={{ pb: 0 }}
                />
                <CardContent>
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="First Name"
                                    name="firstname"
                                    fullWidth
                                    value={formData.firstname}
                                    onChange={handleChange}
                                    required
                                    variant="outlined"
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Last Name"
                                    name="lastname"
                                    fullWidth
                                    value={formData.lastname}
                                    onChange={handleChange}
                                    required
                                    variant="outlined"
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Username"
                                    name="username"
                                    fullWidth
                                    value={formData.username}
                                    onChange={handleChange}
                                    required
                                    variant="outlined"
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Password"
                                    name="password"
                                    type="password"
                                    fullWidth
                                    value={formData.password}
                                    onChange={handleChange}
                                    required
                                    variant="outlined"
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Confirm Password"
                                    name="confirmPassword"
                                    type="password"
                                    fullWidth
                                    value={formData.confirmPassword}
                                    onChange={handleChange}
                                    required
                                    variant="outlined"
                                    size="small"
                                />
                            </Grid>
                            {error && (
                                <Grid item xs={12}>
                                    <Typography color="error" variant="body2">
                                        {error}
                                    </Typography>
                                </Grid>
                            )}
                            <Grid item xs={12}>
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    sx={{
                                        backgroundColor: '#1976d2',
                                        color: '#fff',
                                        '&:hover': {
                                            backgroundColor: '#1565c0',
                                        },
                                        textTransform: 'none',
                                        py: 1.2,
                                    }}
                                >
                                    Register
                                </Button>
                            </Grid>
                            <Grid item xs={12}>
                                <Button
                                    fullWidth
                                    variant="outlined"
                                    onClick={() => navigate('/login')}
                                    sx={{
                                        borderColor: '#1976d2',
                                        color: '#1976d2',
                                        '&:hover': {
                                            backgroundColor: '#f0f0f0',
                                        },
                                        textTransform: 'none',
                                        py: 1.2,
                                    }}
                                >
                                    Login
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </CardContent>
            </Card>
        </Box>
    );
}
